﻿import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetMarketByName } from 'api/marketing';
import { StrikeThroughHeader } from 'components/Headers/strikethrough-header/strikethrough-header';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import MarketingSection from '../Components/MarketingSection';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import MarketingFormsTable from '../Components/MarketingFormsTable';

export default function MarketingItem({ item }) {
  const query = useQuery({
    queryKey: ['GetMarketByName', item],
    queryFn: () => GetMarketByName({ Name: item })(),
    enabled: !!item,
  });

  const divStyle = {
    fontFamily: 'Open Sans',
    fontSize: '24px',
  };

  function createMarkup(text) {
    return {
      __html: text,
    };
  }

  if (query.isPending) {
    return (
      <div id="marketing-root">
        <LoadingIndicator key="loading" />
      </div>
    );
  }
  if (query.isError) {
    return (
      <>
        <StrikeThroughHeader>Marketing and Branding</StrikeThroughHeader>
        <div>
          Marketing Item Not Found. This marketing item may have been removed from the site.
        </div>
      </>
    );
  }

  console.log(query.data);

  if (query.isSuccess && query.data) {
    return (
      <>
        <div id="bootstrap-overrides">
          <h4>{query.data.campaignName}</h4>
          <StrikeThroughHeader>{query.data.itemName}</StrikeThroughHeader>
          <div style={{ textAlign: 'right', margin: '1em 0 1em 0' }}>
            <Button color="primary" size="small" variant="contained" onClick={() => {}}>
              <NavLink
                className={({ isActive }) => `nav-link${isActive ? ' current' : ''}`}
                to="/Marketing"
                style={{ color: 'white', padding: '0' }}
              >
                Back
              </NavLink>
            </Button>
          </div>
          <Paper elevation={1} style={{ paddingTop: '1em', paddingLeft: '1em' }}>
            {query.data.imageName && query.data.overview != '<p></p>\n' && (
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid size={6}>
                  <div>
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontFamily: 'Open Sans',
                        }}
                      >
                        Cost Group:{' '}
                      </div>{' '}
                      <div style={{ display: 'inline-block' }}>{query.data.costGroupName} </div>
                    </div>
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          margin: '0 0 0 1em',
                          fontFamily: 'Open Sans',
                        }}
                      >
                        Markets Served:
                      </div>{' '}
                      <div style={{ display: 'inline-block' }}>
                        {query.data.marketServedConcatenated}{' '}
                      </div>
                    </div>
                    {/* <div style={{ margin: '1em 0 1em 0', fontFamily: 'Open Sans' }} dangerouslySetInnerHTML={createMarkup(query.data.overview)} /> */}
                    {query.data.overview && (
                      <MarketingSection header="" text={query.data.overview} />
                    )}
                  </div>
                </Grid>
                {query.data.imageName && (
                  <Grid size={6}>
                    <div style={{ textAlign: 'center' }}>
                      <img style={{ width: '85%' }} src={'/CmsImages/' + query.data.imageName} />
                    </div>
                  </Grid>
                )}
              </Grid>
            )}
            {!query.data.imageName && query.data.overview != '<p></p>\n' && (
              <>
                <Grid size={'12'}>
                  <div>
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontFamily: 'Open Sans',
                        }}
                      >
                        Cost Group:
                      </div>{' '}
                      <div style={{ display: 'inline-block' }}>{query.data.costGroupName}</div>
                    </div>
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          margin: '0 0 0 1em',
                          fontFamily: 'Open Sans',
                        }}
                      >
                        Markets Served:
                      </div>{' '}
                      <div style={{ display: 'inline-block' }}>
                        {' '}
                        {query.data.marketServedConcatenated}{' '}
                      </div>
                    </div>
                    {/* <div style={{ margin: '1em 0 1em 0', fontFamily: 'Open Sans' }} dangerouslySetInnerHTML={createMarkup(query.data.overview)} /> */}
                    {query.data.overview && (
                      <MarketingSection header="" text={query.data.overview} />
                    )}
                  </div>
                </Grid>
              </>
            )}
            {query.data.whereToBegin && (
              <MarketingSection header="Where to Begin" text={query.data.whereToBegin} />
            )}
            {query.data.tipsAndTricks && (
              <MarketingSection header="Tips and Tricks" text={query.data.tipsAndTricks} />
            )}
            {query.data.relatedResources && (
              <MarketingSection header="Related Resources" text={query.data.relatedResources} />
            )}
            <div>
              <MarketingFormsTable formIDs={query.data.formsConcatenated} />
            </div>
          </Paper>
        </div>
      </>
    );
  }
  return <>No Query Return</>;
}
